import { useMemo, useState } from "react";

import { Popover } from "@/components/ui";

import { Dot, Eyebrow } from "../components/Text";
import { useConsole } from "../store";

const CHOICES = 6;

/** The one loaded space, and the control that sets it. Load is not Start. */
export function LoadedSpaceControl() {
  const [query, setQuery] = useState("");
  const spaces = useConsole((state) => state.spaces);
  const loaded = useConsole((state) => state.loaded);
  const load = useConsole((state) => state.load);
  const unload = useConsole((state) => state.unload);

  const row = spaces.find((one) => one.space.space_id === loaded?.space_id) ?? null;
  const needle = query.trim().toLowerCase();

  const matched = useMemo(() => {
    const active = spaces.filter((one) => one.space.state !== "archived");
    if (needle === "") return active;
    return active.filter((one) =>
      `${one.space.name ?? ""} ${one.space.join_code}`.toLowerCase().includes(needle),
    );
  }, [spaces, needle]);

  return (
    <div className="cx-loadctl">
      <Eyebrow>Loaded space</Eyebrow>
      <Popover
        side="top"
        menuLabel="Loaded space"
        minWidth={260}
        triggerClassName="cx-loadctl-btn"
        label={
          <>
            <Dot tone={row === null ? "off" : "live"} />
            <span>{row === null ? "None" : (row.space.name ?? row.space.join_code)}</span>
          </>
        }
      >
        {(close) => (
          <>
            <input
              className="cx-facet-find"
              value={query}
              placeholder="Find a space"
              aria-label="Find a space"
              onChange={(event) => {
                setQuery(event.target.value);
              }}
            />
            {matched.slice(0, CHOICES).map((one) => (
              <button
                type="button"
                role="menuitem"
                key={one.space.space_id}
                className="al-popover-item"
                aria-current={loaded?.space_id === one.space.space_id}
                onClick={() => {
                  load(one.space.space_id);
                  close();
                }}
              >
                <span>{one.space.name ?? one.space.join_code}</span>
                <span className="cx-code">{one.space.join_code}</span>
              </button>
            ))}
            {matched.length > CHOICES ? (
              <div className="al-popover-label">{`${String(matched.length - CHOICES)} more`}</div>
            ) : null}
            {matched.length === 0 ? <div className="al-popover-label">No matches</div> : null}
            {row === null ? null : (
              <>
                <div className="al-popover-sep" />
                <button
                  type="button"
                  role="menuitem"
                  className="al-popover-item"
                  onClick={() => {
                    unload();
                    close();
                  }}
                >
                  Unload
                </button>
              </>
            )}
          </>
        )}
      </Popover>
    </div>
  );
}
